import { render } from "./SoundMeasurements.vue?vue&type=template&id=20443d92&scoped=true"
const script = {}

import "./SoundMeasurements.vue?vue&type=style&index=0&id=20443d92&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-20443d92"

export default script